<script setup>
import { useCustomizerStore } from '@/stores/customizer';
import { useTenantStore } from '@/stores/tenantStore';
import { computed, ref } from 'vue';

const customizer = useCustomizerStore();
const tenantStore = useTenantStore();

// ✅ Detectar se está em modo escuro
const isDark = computed(() => {
    return (
        customizer.actTheme === 'DARK_BLUE_THEME' ||
        customizer.actTheme === 'DARK_AQUA_THEME' ||
        customizer.actTheme === 'DARK_ORANGE_THEME' ||
        customizer.actTheme === 'DARK_PURPLE_THEME' ||
        customizer.actTheme === 'DARK_GREEN_THEME' ||
        customizer.actTheme === 'DARK_CYAN_THEME'
    );
});

// ✅ Cor do texto baseado no tema
const textColor = computed(() => {
    return isDark.value ? 'white' : '#2A3547';
});

// Logo do tenant (multi-tenant): branding.logo é uma URL relativa servida pelo
// backend do próprio tenant OU uma URL externa. Só exibimos a imagem quando ela
// existe e carrega; caso contrário, mantemos o rótulo neutro "HB / Hub Backoffice"
// (nunca a marca de outro tenant). O branding já está carregado antes do mount,
// então não há flash. `@error` cai no fallback se a URL quebrar.
const logoError = ref(false);
const tenantLogo = computed(() => {
    const logo = tenantStore.branding.logo;
    return logo && !logoError.value ? logo : '';
});
const tenantTitle = computed(() => tenantStore.titulo);
</script>

<template>
    <div class="d-flex align-center">
        <!-- Marca do tenant: logo (quando definido) OU avatar neutro "HB" -->
        <img
            v-if="tenantLogo"
            :src="tenantLogo"
            :alt="tenantTitle"
            class="tenant-logo"
            @error="logoError = true"
        />
        <div
            v-else
            class="d-flex align-center justify-center rounded-circle bg-primary"
            style="width: 40px; height: 40px; min-width: 40px"
        >
            <span class="text-h5 text-white font-weight-bold">HB</span>
        </div>

        <!-- Nome do produto SEMPRE ao lado da marca — "Hub Backoffice" em todos os tenants
             (antes, tenant com logo mostrava só a imagem e ficava sem o nome). -->
        <div class="ml-4">
            <h2 class="text-h6 font-weight-bold mb-0" :style="{ color: textColor }">Hub Backoffice</h2>
        </div>
    </div>
</template>

<style scoped>
/* Logo + nome "Hub Backoffice" ao lado: o logo é limitado para deixar espaço ao texto no
   header expandido; no rail colapsado (width 70) o drawer recorta o excesso, como antes. */
.tenant-logo {
    display: block;
    max-height: 40px;
    max-width: 110px;
    width: auto;
    object-fit: contain;
}
</style>
